import * as React from 'react'
import { Button, Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import moment from 'moment';
import { JobMode } from '../../Job'
import { copyObject, randomId } from '../../../../../utils'

import { getVariableValue, VariableDocumentT, setValueVariables } from '../DocumentVariables'
import { VariablesObj, DefaulVariablesByJobType, CompanyT } from '../../../../../types/Company'
import * as _ from "lodash";

import { AxiosInstance } from '../../../../../utils/RequestMethods'
import config from '../../../../../constants/config'
import EstimateLineItem from './EstimateLineItem';

import ButtonLoading from '../../../../../components/ButtonLoading/ButtonLoading';
import ListAgreements from '../ListAgreements';
import { getMinimumTime, prepareJobAmount } from '../../JobUtils';
import { EstimateLineItemObj, EstimateObj } from '../../InitObjectJob';
import { AgreementT, EstimateLineItemT, JobT } from '../../../../../types/Job';
import { IAppState } from '../../../../../redux/reducers';
import { currentUserIsAdmin, currentUserIsManager, getCurrentUserRoles } from '../../../../../utils/currentUser';
import { parseFloatTotal } from '../../../../../utils/utilsT';

const ParseEstimate = {
    lineItems: () => {

    }
}







interface EstimateProps {

    job: JobT
    jobOrigin: JobT
    jobMode: JobMode
    nextDocument(): void
    refreshJob(newJob: JobT): void
    saveJob(): Promise<JobT>
    updateJob(key: string, value: any): void
    updateDocument(key: string, value: any): void

}






import { getVariablesEsitmate, lineItemsEstimate, estimateIsDirty, getAgreementsEstimate, isAgreedEstimate } from './EstimateUtils'



const Estimate: React.FunctionComponent<EstimateProps> = ({ job, jobOrigin, jobMode, nextDocument, refreshJob, saveJob, updateJob, updateDocument }): JSX.Element => {

    let auth = useSelector((state: IAppState) => state.auth)

    const [isSaving, setIsSaving] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [companyVariables, setCompanyVariables] = React.useState(VariablesObj)
    const [currentChange, setCurrentChange] = React.useState(null)
    const [msgError, setMsgError] = React.useState('');

    const userRole = getCurrentUserRoles()
    const isManager = currentUserIsManager()

    // register function filter when parse job
    React.useEffect(() => {

    }, [])


    // effect when update company
    React.useEffect((): void => {
        if (job?.companyInfo?.variables) {
            setCompanyVariables({ ...VariablesObj, ...job.companyInfo.variables })
        }
    }, [job?.companyInfo])







    const addLineItem = (jobType: string = null): void => {
        let documentsClone = copyObject(job.documents)
        if (documentsClone.estimate == null) documentsClone.estimate = copyObject(EstimateObj)
        //
        let lineItemClone = generateLineItem(jobType)

        let lineItems = lineItemsEstimate(job);

        lineItems.push(lineItemClone)

        let variables = setValueVariables('lineItems', lineItems, getVariablesEsitmate(job))
        if (!estimateIsDirty(job)) {
            variables = setValueVariables('dirty', true, variables)
        }
        documentsClone.estimate.variables = copyObject(variables);
        updateDocument('estimate', documentsClone.estimate)
        // updateJob('documents', documentsClone)
    }



    // estimateLineItems
    const estimateLineItems = (): Array<JSX.Element> | null => {
        if (job?.documents?.estimate != null) {
            return lineItemsEstimate(job).map((lineItem, i) => {
                return (
                    <div key={i}>
                        <EstimateLineItem
                            editable={isManager}
                            lineItem={lineItem}
                            updateLineItem={updateLineItem}
                            removeLineItem={removeLineItem}
                            companyVariables={companyVariables}
                            index={i}
                        />
                    </div>
                )
            })

        }
        return null;
    }

    /**
     * generateLineItem
     * @param jobType
     * @returns
     */
    const generateLineItem = (jobType: string = null): EstimateLineItemT => {
        let lineItemClone: EstimateLineItemT = copyObject(EstimateLineItemObj)
        let minimumTime = getMinimumTime(job)

        if (jobType != null) {
            let item = getDefaultItem(jobType)
            lineItemClone.item = item
            if (companyVariables[item]) {
                lineItemClone.rate = companyVariables[item].value
                lineItemClone.units = parseFloat(`${minimumTime}`)
                lineItemClone.total = lineItemClone.rate * lineItemClone.units
            }
        }

        return lineItemClone;
    }

    /**
     *
     * @param jobType
     * @returns
     */
    const getDefaultItem = (jobType: string = null) => {
        if (jobType && DefaulVariablesByJobType[jobType]) {
            return DefaulVariablesByJobType[jobType]
        }
        return DefaulVariablesByJobType['all']
    }


    /**
     *
     * @param index
     */
    const removeLineItem = (index: number): void => {
        let documentsClone = copyObject(job.documents)
        let lineItems = lineItemsEstimate(job)
        //documentsClone.estimate.lineItems.splice(index, 1)
        const filteredItems = lineItems.slice(0, index).concat(lineItems.slice(index + 1, lineItems.length))

        // When the first item is removed, it should immediately place an empty card there
        if (filteredItems.length <= 0) {
            let item = generateLineItem(job.jobType)
            filteredItems.push(item)
        }

        documentsClone.estimate.variables = setValueVariables('lineItems', filteredItems, job.documents.estimate.variables)
        updateDocument('estimate', documentsClone.estimate)
        // updateJob('documents', documentsClone)
    }

    // saveEstimate
    const saveEstimate = async (): Promise<string> => {
        setIsSaving(true)
        //  refBtnSave.current.startFetching();
        try {
            let data = await saveJob();
            if (data) {
                setCurrentChange(job.documents.estimate.variables)

                setTimeout(() => {
                    refreshJob(data)
                    setIsSaving(false)

                }, 2000);

                let msg = 'Estimate saved.'
                return msg;
            }
        } catch (error) {
            console.log("error", error)
            //  refBtnSave && refBtnSave.current && refBtnSave.current.showMsg(error.message ? error.message : "" + error, false)
            setTimeout(() => {
                setIsSaving(false)
            }, 2000);
            throw new Error(error);
        }

    }

    //  saveAcknowledge
    const clickSaveAcknowledge = async (): Promise<void> => {
        // disabled Acknowledge
        setChecked(true)

        try {
            let res = await saveAcknowledge();
            setChecked(false)

            if (res && res.data) {
                let data: JobT = res.data
                refreshJob(data)
                setCurrentChange(job.documents.estimate.variables)
                // nextDocument()
            }
        } catch (error) {
            setChecked(false)
            setMsgError(error.message ? error.message : "" + error)
            // clearn UI Message Error
            setTimeout(() => {
                setMsgError('')
            }, 2000);
            console.log("error", error)
        }
    }

    /**
     *
     */
    const saveAcknowledge = async (): Promise<any> => {
        let url = `${config.url.wpJson}/wp/v2/jobs/${job.id}/agreements`
        let params = {
            name: 'estimate',
            type: 'acknowledgement',
            clause: 'I acknowledge that I have been given a copy of this estimate to keep for my records.',
            content: job.documents.estimate.variables,
        }
        return AxiosInstance.post(url, params).then((res) => {
            return res
        })
    }

    //  sumLineItems
    const sumLineItems = (lis: Array<EstimateLineItemT>): number => {
        if (lis.length == 0) return 0
        let lineItem = lis.shift()
        let total = 0
        if (lineItem.item == 'discount') total = sumLineItems(lis) - Number(parseFloat(`${lineItem.total}`).toFixed(2))
        else total = Number(parseFloat(`${lineItem.total}`).toFixed(2)) + sumLineItems(lis)
        return parseFloat(`${parseFloatTotal(total)}`)
    }

    // updateLineItem
    const updateLineItem = (key: string, value: any, index: number): void => {
        let documentsClone = copyObject(job.documents)
        let lineItems = lineItemsEstimate(job)
        let lineItem = lineItems[index]
        let variables = job.documents.estimate.variables;

        // when update line item update estimate dirty
        if (!estimateIsDirty(job) && lineItem[key] != value) {
            variables = setValueVariables('dirty', true, variables);
        }

        lineItem[key] = value
        // update rate and units  pull in  settings  company if item exists
        if (key == 'item' && companyVariables[value]) {
            lineItem['rate'] = companyVariables[value].value
            // lineItem['units'] = reflectorLabel(companyVariables[value],false)
            lineItem.total = lineItem.rate * lineItem.units
        }

        if (key == 'rate' || key == 'units') lineItem.total = lineItem.rate * lineItem.units
        lineItems[index] = copyObject(lineItem)
        variables = setValueVariables('lineItems', lineItems, variables)

        documentsClone.estimate.variables = copyObject(variables)
        updateDocument('estimate', documentsClone.estimate)
        // updateJob('documents', documentsClone)

        // update Current Estimate
        setCurrentChange(documentsClone.estimate.variables)
    }

    /**
     *
     * @param lineItems
     */
    const setEstimateByAgreement = (variables: Array<VariableDocumentT>): void => {
        if (!currentChange) {
            setCurrentChange(job.documents.estimate.variables)
        }

        let documentsClone = copyObject(job.documents)
        documentsClone.estimate.variables = variables
        updateJob('documents', documentsClone)
    }


    //
    const isChangedEstimate = (): boolean => {
        let var1 = copyObject(getVariablesEsitmate(job, false))
        let var2 = copyObject(getVariablesEsitmate(jobOrigin, false))
        return !_.isEqual(var2, var1)
    }


    const changeCurrentEstimate = (): void => {
        if (currentChange) {
            let documentsClone = copyObject(job.documents)
            documentsClone.estimate.variables = currentChange
            updateDocument('estimate', documentsClone.estimate)
            // updateJob('documents', documentsClone)
        }
    }

    const renderSignEstimate = (): JSX.Element => {
        if (jobMode != JobMode.Edit) {
            return null;
        }

        if ((userRole.includes('administrator') || userRole.includes('manager')) && (!isAgreedEstimate(job) || isChangedEstimate())) {
            return (
                <div>
                    <span className="text-danger">Client has not yet agreed to Estimate.</span>
                </div>
            )

        } else if (userRole.includes('client')) {
            return (
                <div>
                    {msgError != '' && <div><span className="text-danger">{msgError}</span></div>}
                    {(checked || isAgreedEstimate(job)) == false && isChangedEstimate() &&
                        <div><span className="text-danger">You must agree to these terms.</span></div>}

                    <div className="d-flex" style={{}}>
                        {/* <div key='custom-inline-checkbox'> */}
                        <Form.Check
                            inline
                            // custom
                            // className='mt-2'
                            disabled={!checked && !isAgreedEstimate(job) && !isChangedEstimate() ? false : true}
                            id={`${"custom-inline-"}`}
                            checked={checked || isAgreedEstimate(job)}
                            type="checkbox"
                            onChange={(e) => {
                                if (!checked) {
                                    clickSaveAcknowledge()
                                }
                            }}
                            label={<p>I acknowledge that I have been given a copy of this estimate to keep for my records.</p>}
                        />
                        {/* </div> */}
                        {/*
                        <Form.Check
                            disabled={!checked && !isAgreedEstimate(job) && !isChangedEstimate() ? false : true}
                            onChange={(e) => {
                                if (!checked) {
                                    clickSaveAcknowledge()
                                }
                            }}
                            checked={checked || isAgreedEstimate(job)}
                            type='checkbox' />
                        <p>I acknowledge that I have been given a copy of this estimate to keep for my recordsee.</p> */}
                    </div>

                </div>
            )
        }
        return null;
    }


    return (
        <div className='w-100'>
            {estimateLineItems()}
            <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr 30px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))' }}>
                    <div>
                        {isManager && <Button
                            onClick={(): void => { addLineItem(job.jobType) }}
                            variant='info'>
                            Add Line Item
                        </Button>}
                    </div>
                    <div>
                        {((isSaving == true || (jobMode == JobMode.Edit && isChangedEstimate()) && isManager)) &&
                            <ButtonLoading
                                className="btn-success"
                                onClickFetching={saveEstimate}>
                                Save Estimate
                            </ButtonLoading>}
                    </div>
                    <div>
                        {currentChange && !_.isEqual(currentChange, getVariablesEsitmate(job)) &&
                            <Button onClick={(): void => { changeCurrentEstimate() }} variant='info'> View Current</Button>}
                    </div>
                </div>
                <div></div>
                <div>
                    <Form.Label><strong>Total, $</strong></Form.Label>
                    <Form.Control
                        className='input-material'
                        disabled
                        value={`${parseFloat(`${sumLineItems(copyObject(lineItemsEstimate(job)))}`).toFixed(2)}`} />
                </div>
                <div></div>

            </div>


            {renderSignEstimate()}
            <a id="anchor-agreement-estimate" ></a>
            <ListAgreements
                agreements={getAgreementsEstimate(job)}
                onClickView={(contant) => {
                    setEstimateByAgreement(contant)
                }}
                currantContent={getVariablesEsitmate(job)}
            />

        </div>
    )
}

export default Estimate
